function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, React.createElement("path", {
  fill: "#737373",
  d: "M173 630 c-92 -6 -126 -23 -156 -81 -23 -44 -17 -87 23 -148 27 -43\n30 -56 30 -125 0 -69 2 -78 20 -83 28 -7 25 -41 -5 -53 -34 -13 -60 -66 -47\n-95 16 -35 72 -50 116 -31 30 12 36 20 36 45 0 42 -20 81 -42 81 -22 0 -25 45\n-4 57 10 6 16 30 18 78 2 54 7 70 19 73 8 1 51 -28 95 -65 123 -106 133 -113\n174 -113 55 0 82 27 162 163 88 149 95 171 75 219 -26 61 -53 72 -191 75 -66\n2 -148 4 -181 6 -33 1 -97 0 -142 -3z m397 -120 c13 -21 15 -16 -38 -105 -31\n-54 -53 -80 -65 -80 -22 0 -183 132 -192 158 -4 10 -1 25 6 33 18 22 275 17\n289 -6z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.0,
    width: "70.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 70.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/theragun.de31db98.svg";
export { SvgComponent as ReactComponent };